export const LOGIN_INIT = 'LOGIN_INIT'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const DEPARTMENTS_INIT = 'DEPARTMENTS_INIT'
export const DEPARTMENTS_SUCCESS = 'DEPARTMENTS_SUCCESS'
export const DEPARTMENTS_ERROR = 'DEPARTMENTS_ERROR'

export const GET_USERS_INIT = 'GET_USERS_INIT'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_ERROR = 'GET_USERS_ERROR'

export const GET_MODULES_INIT = 'GET_MODULES_INIT'
export const GET_MODULES_SUCCESS = 'GET_MODULES_SUCCESS'
export const GET_MODULES_ERROR = 'GET_MODULES_ERROR'

export const GET_ROLES_INIT = 'GET_ROLES_INIT'
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS'
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR'
export const NEW_WEBSITE_INIT = 'NEW_WEBSITE_INIT'

export const NEW_WEBSITE_SUCCESS = 'NEW_WEBSITE_SUCCESS'
export const NEW_WEBSITE_ERROR = 'NEW_WEBSITE_ERROR'

export const GET_WEBSITES_INIT = 'GET_WEBSITES_INIT'
export const GET_WEBSITES_SUCCESS = 'GET_WEBSITES_SUCCESS'
export const GET_WEBSITES_ERROR = 'GET_WEBSITES_ERROR'

export const NEW_TOURTYPE_INIT = 'NEW_TOURTYPE_INIT'
export const NEW_TOURTYPE_SUCCESS = 'NEW_TOURTYPE_SUCCESS'
export const NEW_TOURTYPE_ERROR = 'NEW_TOURTYPE_ERROR'

export const GET_TOURTYPES_INIT = 'GET_TOURTYPES_INIT'
export const GET_TOURTYPES_SUCCESS = 'GET_TOURTYPES_SUCCESS'
export const GET_TOURTYPES_ERROR = 'GET_TOURTYPES_ERROR'

export const GET_SHOPPING_CARTS_INIT = 'GET_SHOPPING_CARTS_INIT'
export const GET_SHOPPING_CARTS_SUCCESS = 'GET_SHOPPING_CARTS_SUCCESS'
export const GET_SHOPPING_CARTS_ERROR = 'GET_SHOPPING_CARTS_ERROR'

export const GET_PAYMENT_TYPES_INIT = 'GET_PAYMENT_TYPES_INIT'
export const GET_PAYMENT_TYPES_SUCCESS = 'GET_PAYMENT_TYPES_SUCCESS'
export const GET_PAYMENT_TYPES_ERROR = 'GET_PAYMENT_TYPES_ERROR'

export const NEW_CATEGORY_INIT = 'NEW_CATEGORY_INIT'
export const NEW_CATEGORY_SUCCESS = 'NEW_CATEGORY_SUCCESS'
export const NEW_CATEGORY_ERROR = 'NEW_CATEGORY_ERROR'

export const GET_CATEGORIES_INIT = 'GET_CATEGORIES_INIT'
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR'

export const GET_PROVIDERS_INIT = 'GET_PROVIDERS_INIT'
export const GET_PROVIDERS_SUCCESS = 'GET_PROVIDERS_SUCCESS'
export const GET_PROVIDERS_ERROR = 'GET_PROVIDERS_ERROR'
export const NEW_LOCATION_INIT = 'NEW_LOCATION_INIT'
export const NEW_LOCATION_SUCCESS = 'NEW_LOCATION_SUCCESS'
export const NEW_LOCATION_ERROR = 'NEW_LOCATION_ERROR'

export const GET_LOCATIONS_INIT = 'GET_LOCATIONS_INIT'
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS'
export const GET_LOCATIONS_ERROR = 'GET_LOCATIONS_ERROR'

export const GET_OPERATORS_INIT = 'GET_OPERATORS_INIT'
export const GET_OPERATORS_SUCCESS = 'GET_OPERATORS_SUCCESS'
export const GET_OPERATORS_ERROR = 'GET_OPERATORS_ERROR'

export const GET_SERVICE_AREA_INIT = 'GET_SERVICE_AREA_INIT'
export const GET_SERVICE_AREA_SUCCESS = 'GET_SERVICE_AREA_SUCCESS'
export const GET_SERVICE_AREA_ERROR = 'GET_SERVICE_AREA_ERROR'

export const GET_TOURS_INIT = 'GET_TOURS_INIT'
export const GET_TOURS_SUCCESS = 'GET_TOURS_SUCCESS'
export const GET_TOURS_ERROR = 'GET_TOURS_ERROR'